import React, { Component } from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import { Modal } from "components/modal/Modal";

//import { GlamboxEndpoints } from "../../core/glambox/GlamboxEndpoints";
//import { ExecuteRequest } from "../../core/glambox/GlamboxApi";
//import GlampointsStyles from "components/glamclub/GlamPointsHistory.module.scss";

import { Container } from "components/grid/Container";
import { Row } from "components/grid/Row";
//import { Col } from "components/grid/Col";

import ShareStylesGP from "components/mgm/ShareGP.module.scss";
import ShareStylesGG from "components/mgm/ShareGG.module.scss";

import { UiActions } from "state/actions/UiActions";
import { GlamboxLocalStore } from "core/glambox/GlamboxLocalStore";

import { CopyToClipBoard } from "utils/CopyToClipBoard";
import { ShareUtils } from "core/utils/ShareUtils";
import { PersonActions } from "state/actions/user/PersonActions";
import { showPortalGp } from "core/utils/SubscriberUtils";
import { NavLink } from "react-router-dom";

class ShareFriends extends Component {
  constructor(props) {
    super(props);

    this.state = {
      couponName: props.person.couponName,
      cupomModalVisible: false,
      editedClass:
        props.person.dateCouponNameEdited === null ? null : "editado",
    };
  }

  copyToClipBoard = (id, props) => {
    return (event) => {
      event.preventDefault();
      CopyToClipBoard.copyToClipBoard(id, props);
    };
  };

  toggleCupomModal = () => {
    this.setState({
      cupomModalVisible: !this.state.cupomModalVisible,
    });
  };

  editCoupon = (event) => {
    const { couponName } = this.props.person;
    const value = event.target.value;
    this.setState({ couponName: value });
  };

  setCouponName = () => {
    let { couponName } = this.state;

    if (couponName !== "" && couponName !== this.props.person.couponName) {
      let couponNameObj = { newCouponName: couponName };

      this.props.setCouponName(Object.assign({}, couponNameObj), (response) => {
        let { statusCode, result } = response;

        if (statusCode === 200) {
          this.setState({ editedClass: "editado" });
          this.props.publishSuccessAlert("Cupom editado com sucesso");
          this.toggleCupomModal();
        } else {
          this.props.publishErrorAlert(result.message);
        }
      });
    }
  };

  renderCupomGG = () => {
    const { person } = this.props;
    let { editedClass } = this.state;
    const pageLink = this.props.page ? this.props.page : "convite";

    let couponLink = `https://sua.glambox.com.br/${pageLink}/?c=${this.state.couponName}`;

    let classes = ["gbBt"];
    classes.push("small");
    classes.push("flat");

    return (
      <Container fluid className={ShareStylesGG["shareLinksMGMGeral"]}>
        <Row
          className={
            "gb-contentblock p-xl-4 p-3 d-flex " +
            ShareStylesGG["shareCupomAndLink"]
          }
        >
          <div
            className={
              "d-flex align-items-center justify-between flex-column flex-lg-row " +
              ShareStylesGG["shareCupomAndLink__body"]
            }
          >
            <div>
              <h3 className={ShareStylesGG["title-share"]}>
                Copie, cole e compartilhe o link:
              </h3>
            </div>
            <div
              className={
                "d-flex justify-between flex-column flex-lg-row " +
                ShareStylesGG["shareCupomAndLink__body__items"]
              }
            >
              <div
                className={
                  "d-flex align-items-center flex-column flex-lg-row " +
                  ShareStylesGG["item"]
                }
              >
                <strong
                  className={"d-flex align-items-center justify-center"}
                  id={"couponName"}
                >
                  {person.couponName}
                </strong>
                <button
                  className={classnames(classes, "default")}
                  id={"copy"}
                  onClick={this.copyToClipBoard("couponName", this.props)}
                >
                  Copiar Cupom
                </button>
              </div>
              <div
                className={
                  "d-flex align-items-center flex-column flex-lg-row " +
                  ShareStylesGG["item"]
                }
              >
                <strong
                  className={"d-flex align-items-center"}
                  id={"linkInvite"}
                >
                  https://sua.glambox.com.br/{pageLink}/?c={person.couponName}
                </strong>
                <button
                  className={classnames(classes, "default")}
                  onClick={this.copyToClipBoard("linkInvite", this.props)}
                >
                  Copiar Link
                </button>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    );
  };

  renderCupomGP = () => {
    const { person } = this.props;
    let { editedClass } = this.state;
    const pageLink = this.props.page ? this.props.page : "convite";

    let couponLink = `https://sua.glambox.com.br/${pageLink}/?c=${this.state.couponName}`;

    let classes = ["gbBt"];
    classes.push("small");
    classes.push("flat");

    return (
      <>
        <Modal
          visible={this.state.cupomModalVisible}
          onCloseModal={this.toggleCupomModal}
        >
          <div className={"d-flex flex-column align-items-center mb-2"}>
            <h3 className={"mb-0"}>Edite seu cupom</h3>
            <small>*você só poderá editá-lo uma única vez</small>
          </div>
          <div className={"d-flex flex-column align-items-center"}>
            <input
              className={"text-center mb-1"}
              type="text"
              value={this.state.couponName}
              onChange={this.editCoupon}
              ref={(ip) => {
                this.myInp = ip;
              }}
            />
            <div className={"d-flex flex-column flex-lg-row-reverse"}>
              <button
                className={"btn btn-sm btn-light-pink mb-1 ml-1"}
                onClick={this.setCouponName}>
                Salvar
              </button>

              <button
                className={"btn btn-sm btn-outline-light-pink mb-1 ml-1"}
                onClick={this.toggleCupomModal}
              >
                Cancelar
              </button>
            </div>
          </div>
        </Modal>

        <Container fluid>
          <div className={ "level-2 p-2 p-xl-5 d-flex flex-column flex-lg-row justify-between " + ShareStylesGP["share-container"]}>

          <div className={" flex-column align-items-center " + ShareStylesGP["rules"]}>
          <h3 className={ShareStylesGP["title-share"]}>
            Copie, cole e compartilhe seu cupom:
          </h3>
          <span>Você pode personalizar o seu cupom, editando uma única vez <NavLink to={"/dados-pessoais/cupom"}>aqui!</NavLink></span>
        </div>
        <div className={"d-flex flex-column flex-lg-row align-items-center center-block" + ShareStylesGP["coupon-name-container"]}>
        <div className={`${ShareStylesGP["coupon-name"]} ${ShareStylesGP[editedClass]}`}
          disabled={true}>
                <strong id={"couponName"}>{this.state.couponName}</strong>
                <span>editado</span>
                {/* <button onClick={this.toggleCupomModal}>
                  <i
                    className="fas fa-pencil-alt"
                    style={{ cursor: "pointer" }}
                  ></i>
                </button> */}
              </div>

              <button
                className={classnames(classes, "default")}
                id={"copy"}
                onClick={this.copyToClipBoard("couponName", this.props)}>
                Copiar Cupom
              </button>

              <div className={`${ShareStylesGP["coupon-name-link"]} ${ShareStylesGP[editedClass]}`}
                disabled={true}>
                <strong id={"linkInvite"} style={{ fontSize: "small" }}>
                  {couponLink}
                </strong>
              </div>

              <button
                className={classnames(classes, "default")}
                onClick={this.copyToClipBoard("linkInvite", this.props)}>
                Copiar Link
              </button>
            </div>
          </div>
        </Container>
      </>
    );
  };

  renderComissao = () => {
       return (
      <div className={"mt-2 level-2 "}> 
        <h3>Comissão</h3>
        {/* VALOR DA COMISSÃO (VAI CHUMBADO MESMO POR QUE SIM) */}
        <div className={"level-2 p-5"} style={{ background: "#fff" }}>
          <p>Esses são os valores das comissões atuais por tipo de assinatura.</p>
        </div>

        <div
          className={
            "d-flex justify-between flex-column flex-lg-row comissao_valores level-2"
          }
        >
          <div className={"wfull"}>
            <div
              className={"d-flex flex-column p-4 gb-contentblock text-center"}
            >
              <strong>Assinatura Mensal</strong>
              <p>
                <span className={"display-2"}>R$15,00</span><br />
                <small>por venda</small>
              </p>
            </div>
          </div>
          <div className={"wfull"}>
            <div
              className={"d-flex flex-column p-4 gb-contentblock text-center"}
            >
              <strong>Assinatura Semestral</strong>
              <p>
                <span className={"display-2"}>R$40,00</span><br />
                <small>por venda</small>
              </p>
            </div>
          </div>
          <div className={"wfull"}>
            <div
              className={"d-flex flex-column p-4 gb-contentblock text-center"}
            >
              <strong>Assinatura Anual</strong>
              <p>
                <span className={"display-2"}>R$60,00</span><br />
                <small>por venda</small>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    let isGp = showPortalGp();

    if (isGp) {
      return (
        <div>
          {this.renderCupomGP()}
          {this.renderComissao()}
        </div>
      );
    } else {
      return <div>{this.renderCupomGG()}</div>;
    }
  }
}

const mapStateToProps = (state) => ({
  ui: state.ui,
  person: state.person.data.person,
  // comissions: state.partnerComissions.data

});

const mapDispatchToProps = (dispatch) => ({
  setCouponName: (couponName, callback) => {
    dispatch(PersonActions.setCouponName(couponName, callback));
  },

  publishSuccessAlert: (message) => {
    dispatch(UiActions.publishSuccessAlert(message));
  },

  publishErrorAlert: (message) => {
    dispatch(UiActions.publishErrorAlert(message));
  },
});

ShareFriends = connect(mapStateToProps, mapDispatchToProps)(ShareFriends);

class ShareSocials extends Component {
  render() {
    const { couponName } = this.props;

    const shareUrl = ` https://sua.glambox.com.br/convite/?c=${couponName}`,
      shareText = `Já experimentou a Glambox? Receba produtos todos os meses de acordo com o seu perfil. Assine com meu cupom e ganhe R$80 OFF no plano anual!`;

    const socialData = {
      whatsapp: `${shareText} ${shareUrl}`,
      facebook: `${shareUrl}`,
      twitter: `${shareText}&url=${shareUrl}`,
      instagram: "",
    };

    return (
      <Container fluid className={ShareStylesGG["footerMGMGeral"]}>
        <Row
          className={
            "p-xl-4 p-3 d-block level-2 " + ShareStylesGG["socialsShare"]
          }
        >
          <div
            className={
              "d-flex align-items-center justify-between flex-column flex-lg-row"
            }
          >
            <h3 className={ShareStylesGG["title-share"]}>
              Compartilhe nas redes sociais:
            </h3>
            <div
              className={
                "d-flex justify-between " + ShareStylesGG["social_content"]
              }
            >
              <svg
                width="34"
                height="34"
                viewBox="0 0 34 34"
                onClick={ShareUtils.ShareToCallback(
                  "whatsapp",
                  socialData["whatsapp"]
                )}
              >
                <path
                  d="M34,16.562a16.719,16.719,0,0,1-24.759,14.5L0,34l3.013-8.886a16.388,16.388,0,0,1-2.4-8.552,16.692,16.692,0,0,1,33.382,0ZM17.309,2.638A14,14,0,0,0,3.276,16.562a13.778,13.778,0,0,0,2.673,8.164L4.2,29.9l5.393-1.714a14.047,14.047,0,0,0,21.754-11.62A14,14,0,0,0,17.309,2.638Zm8.429,17.739c-.1-.169-.376-.271-.784-.474s-2.422-1.185-2.8-1.32-.649-.2-.921.2-1.057,1.32-1.3,1.591-.477.306-.887.1a11.2,11.2,0,0,1-3.29-2.015,12.239,12.239,0,0,1-2.276-2.811c-.238-.406-.025-.626.179-.828.184-.182.41-.474.614-.711a2.721,2.721,0,0,0,.409-.677.74.74,0,0,0-.034-.711c-.1-.2-.921-2.2-1.262-3.014s-.681-.677-.92-.677S11.963,9,11.69,9a1.51,1.51,0,0,0-1.091.508A4.54,4.54,0,0,0,9.168,12.9a7.855,7.855,0,0,0,1.671,4.2c.2.27,2.83,4.5,6.989,6.129s4.16,1.083,4.91,1.015A4.138,4.138,0,0,0,25.5,22.307,3.384,3.384,0,0,0,25.738,20.377Z"
                  fill="#747f8b"
                />
              </svg>
              <svg
                width="18.382"
                height="34"
                viewBox="0 0 18.382 34"
                onClick={ShareUtils.ShareToCallback(
                  "facebook",
                  socialData["facebook"]
                )}
              >
                <path
                  d="M39.767.007,35.358,0C30.4,0,27.2,3.284,27.2,8.367v3.858H22.77a.693.693,0,0,0-.693.694v5.59a.693.693,0,0,0,.693.693H27.2v14.1A.693.693,0,0,0,27.9,34h5.784a.693.693,0,0,0,.693-.693V19.2h5.183a.693.693,0,0,0,.693-.693l0-5.59a.694.694,0,0,0-.694-.694H34.374V8.955c0-1.572.375-2.37,2.422-2.37h2.97a.693.693,0,0,0,.693-.693V.7A.694.694,0,0,0,39.767.007Z"
                  transform="translate(-22.077)"
                  fill="#747f8b"
                />
              </svg>
              <svg
                width="34"
                height="28.282"
                viewBox="0 0 34 28.282"
                onClick={ShareUtils.ShareToCallback(
                  "twitter",
                  socialData["twitter"]
                )}
              >
                <path
                  d="M33.46,37.781a13.463,13.463,0,0,1-2.344.791A7.309,7.309,0,0,0,33.045,35.5h0a.383.383,0,0,0-.561-.446h0A13.528,13.528,0,0,1,28.9,36.533a.913.913,0,0,1-.224.028.95.95,0,0,1-.628-.24,7.33,7.33,0,0,0-4.85-1.83,7.837,7.837,0,0,0-2.322.359,7.1,7.1,0,0,0-4.786,5.117,7.819,7.819,0,0,0-.174,2.7.262.262,0,0,1-.066.206.272.272,0,0,1-.2.092h-.026A19.22,19.22,0,0,1,2.412,35.9h0a.383.383,0,0,0-.628.049h0a7.338,7.338,0,0,0,1.193,8.91A6.569,6.569,0,0,1,1.3,44.216h0a.383.383,0,0,0-.569.33h0a7.339,7.339,0,0,0,4.281,6.762l-.157,0a6.6,6.6,0,0,1-1.235-.118h0a.383.383,0,0,0-.437.493h0a7.347,7.347,0,0,0,5.8,5,13.526,13.526,0,0,1-7.576,2.3H.567a.561.561,0,0,0-.549.423.581.581,0,0,0,.278.642,20.119,20.119,0,0,0,10.109,2.726,20.4,20.4,0,0,0,8.639-1.833A19.078,19.078,0,0,0,25.366,56.2a20.767,20.767,0,0,0,3.871-6.482,20.478,20.478,0,0,0,1.316-7.095v-.112a1.247,1.247,0,0,1,.467-.971,14.488,14.488,0,0,0,2.915-3.2h0a.383.383,0,0,0-.474-.563Z"
                  transform="translate(0 -34.491)"
                  fill="#747f8b"
                />
              </svg>
              <svg
                width="34"
                height="34"
                viewBox="0 0 34 34"
                onClick={ShareUtils.ShareToCallback(
                  "instagram",
                  socialData["instagram"]
                )}
              >
                <path
                  d="M9.383,34A9.394,9.394,0,0,1,0,24.617V9.383A9.394,9.394,0,0,1,9.383,0H24.617A9.394,9.394,0,0,1,34,9.383V24.617A9.394,9.394,0,0,1,24.617,34ZM3.017,9.383V24.617a6.373,6.373,0,0,0,6.366,6.367H24.617a6.373,6.373,0,0,0,6.367-6.367V9.383a6.373,6.373,0,0,0-6.367-6.366H9.383A6.373,6.373,0,0,0,3.017,9.383ZM8.24,17A8.761,8.761,0,1,1,17,25.761,8.77,8.77,0,0,1,8.24,17Zm3.016,0A5.744,5.744,0,1,0,17,11.256,5.751,5.751,0,0,0,11.255,17Zm13.31-7.542a2.211,2.211,0,1,1,1.563.648A2.229,2.229,0,0,1,24.566,9.458Z"
                  fill="#747f8b"
                />
              </svg>
            </div>
          </div>
        </Row>
      </Container>
    );
  }
}

export { ShareFriends, ShareSocials };
